import { Community } from "@entities";
import { Box, MenuItem, Select } from "@mui/material";
import { type HyperTableFilter } from "@shared/frontend/hyper-table";

export const COMMUNITY_TABLE_FILTERS: HyperTableFilter<Community>[] = [
  { fieldName: "name", id: "name" },
  { fieldName: "description", id: "description" },
  { fieldName: "parentCommunity.name", id: "parentCommunity", caption: "קהילת אם" },
  {
    id: "hasVolunteers",
    icon: "boolean",
    caption: "יש מתנדבים",
    renderFilter: ({ onSave, meta }) => {
      const value = (meta.value as string) ?? "";
      return (
        <Box sx={{ p: 1, minWidth: 180 }}>
          <Select
            fullWidth
            size="small"
            displayEmpty
            value={value}
            onChange={(event) => {
              const next = event.target.value;
              onSave({
                value:
                  next === "yes"
                    ? Community.hyperFilter({ associations: { $some: {} } })
                    : next === "no"
                      ? Community.hyperFilter({ associations: { $none: {} } })
                      : {},
                meta: {
                  value: next,
                  text: next === "yes" ? "יש מתנדבים" : next === "no" ? "אין מתנדבים" : "",
                },
              });
            }}
          >
            <MenuItem value="">הכל</MenuItem>
            <MenuItem value="yes">יש מתנדבים</MenuItem>
            <MenuItem value="no">אין מתנדבים</MenuItem>
          </Select>
        </Box>
      );
    },
  },
];
